/** 美国合规三件套的共享类型。字段名对齐合规文档里服务端的返回。 */

// ── 地理围栏 ────────────────────────────────────────────────────────────
/**
 * unknown  还没查过
 * checking 正在取定位 / 校验中
 * compliant 校验通过，可进游戏
 * denied   用户拒绝了定位权限，或浏览器取不到位置
 * illegal  拿到位置了，但服务端判定不在允许区域
 */
export type GeoStatus =
  | "unknown"
  | "checking"
  | "compliant"
  | "denied"
  | "illegal";

/** 前端上报给服务端 verify 的定位载荷（对齐文档 verifyPayload 去掉的字段之外的部分）。 */
export interface GeoPayload {
  latitude: number;
  longitude: number;
  /** 水平精度（米），服务端 verifyPayload 会 unset，这里带上只为排查用 */
  accuracy?: number;
  externalId?: string;
  externalEmail?: string;
}

/** 服务端 verify 的判定结果。 */
export interface GeoVerifyResult {
  compliant: boolean;
  score?: number;
  error?: string;
}

// ── KYC（Didit 那套，与现有 LatAm/PH 的 /api/kyc/persist 不是一回事）────────
/**
 * 文档里 kycIdCallback 写死的取值：
 * 0 未开始 / 1 通过(Approved) / 2 拒绝(Declined) / 3 待重试(Resubmitted、Expired…) / 4 审核中
 */
export const KYC_ID_STATUS = {
  NOT_STARTED: 0,
  APPROVED: 1,
  DECLINED: 2,
  RETRY: 3,
  IN_REVIEW: 4,
} as const;

export type KycIdStatus = (typeof KYC_ID_STATUS)[keyof typeof KYC_ID_STATUS];

/** getKycStatus 的返回。三项各自独立：年龄 / 身份证件 / 地址证明。 */
export interface UsKycStatus {
  kycAge: number;
  kycId: KycIdStatus;
  kycPoa: number;
}

/** INFO 表单提交的资料（对应截图里的 COUNTRY/STATE/CITY/ADDRESS/NAME/BIRTHDAY/ZIP）。 */
export interface UsKycProfile {
  countryId: string;
  state: string;
  city: string;
  address: string;
  firstName: string;
  lastName: string;
  birthDay: string;
  zipCode: string;
}

// ── AMOE ───────────────────────────────────────────────────────────────
/** Get Free SC 里那个 12 位一次性邮寄请求码。 */
export interface AmoeKey {
  /** 12 位纯数字 */
  code: string;
  /** 展示后 30 天过期，秒级时间戳；服务端没给就留空 */
  expireAt?: number;
}
